import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { read, create } from 'actions/data'
import { DATA_API_URL } from 'utils/AllURLs'
import Button from 'components/theme/Button'
import Field from 'components/theme/Field'
import { toggleDialog } from 'actions/view'
import MarkdownWithEllipsis from 'components/VastGPT/MarkdownWithEllipsis'

class AddOrEditKnowledgePage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      content: '',
      title: '',
      initialContent: '',
      initialTitle: '',
      loading: false,
      editing: false,
    }
  }

  componentDidMount() {
    // this.props.read(
    //   'knowledge/POST',
    //   'schema',
    //   null,
    //   null,
    //   'object',
    //   'knowledge/POST',
    //   null,
    //   `${DATA_API_URL}/schema/knowledge/POST`,
    // )

    if (this.props.id && this.props.id !== 'new') {
      this.props
        .read(
          this.props.id,
          'knowledge',
          null,
          null,
          'object',
          null,
          null,
          `${DATA_API_URL}/knowledge/${this.props.id}`,
        )
        .then(payload => {
          console.log(payload)
          // const parsedValue = defaultMarkdownParser.parse(payload?.content)

          // this.easyMDE.value(payload?.content)

          this.setState({
            content: payload?.content,
            title: payload?.title,
            initialContent: payload?.content,
            initialTitle: payload?.title,
          })
        })
    } else {
      if (this.props.title) {
        this.setState({
          title: this.props.title,
          initialTitle: this.props.title,
        })
      }

      if (this.props.content) {
        // const parsedValue = defaultMarkdownParser.parse(this.props.content)
        this.setState({
          content: this.props.content,
          initialContent: this.props.content,
        })
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.editing && !prevProps.editing) {
      this.easyMDE = new window.EasyMDE({
        element: this.textarea,
        toolbar: [
          'bold',
          'italic',
          'strikethrough',
          'heading',
          'heading-smaller',
          'heading-bigger',
          'heading-1',
          'heading-2',
          'heading-3',
          'code',
          'quote',
          'unordered-list',
          'ordered-list',
          'clean-block',
          'link',
          'image',
          'horizontal-rule',
          'preview',
          'side-by-side',
          'guide',
          'undo',
          'redo',
        ],
      })

      this.easyMDE.value(this.state.content)
    }
  }

  render() {
    const buttonDisabled =
      this.state.loading ||
      !this.state.content ||
      this.state.content === '<p></p>' ||
      (this.props.id !== 'new' &&
        this.state.content === this.state.initialContent &&
        this.state.title === this.state.initialTitle)

    return (
      <div style={{ width: '100%', height: '100%', padding: 20 }}>
        <div
          style={{
            width: '100%',
            height: '100%',
            borderRadius: 20,
            border: '1px solid gray',
            position: 'relative',
            backgroundColor: '#fff',
            padding: this.props.dialog ? '40px 20px 20px' : 20,
          }}
        >
          <div>
            {/* <Typography variant="h5" gutterBottom>
              Give a clear title or question for this knowledge item
            </Typography> */}
            <Field
              label="Title/Question"
              placeholder="Give a clear title or question for this knowledge item"
              variant="standard"
              value={this.state.title}
              handleChange={(name, value) => this.setState({ title: value })}
            />
          </div>
          <div>
            {/* <textarea ref={this.ref} id="EasyMDE-AddOrEditKnowledge-text-area" /> */}
            {this.props.editing ? (
              <textarea
                ref={element => {
                  this.textarea = element
                }}
              ></textarea>
            ) : (
              <MarkdownWithEllipsis markdown={this.state.content} />
            )}
          </div>
          <Button
            disabled={buttonDisabled}
            variant="contained"
            onClick={() => {
              console.log(this.easyMDE.value())
            }}
            // onClick={() => {
            //   this.setState({ loading: true })

            //   this.props
            //     .create({
            //       entity: {
            //         id: this.props.id === 'new' ? undefined : this.props.id,
            //         title: this.state.title || undefined,
            //         content: defaultMarkdownSerializer.serialize(
            //           this.state.content,
            //         ),
            //         internal: true,
            //         external: false,
            //       },
            //       entityType: 'knowledge',
            //       url: `${DATA_API_URL}/knowledge`,
            //       hasSchema: false,
            //     })
            //     .then(payload => {
            //       if (this.props.dialog) {
            //         this.props.toggleDialog({
            //           open: false,
            //           dialog: 'AddOrEditKnowledge',
            //         })
            //       } else {
            //         if (this.props.id === 'new' && payload?.id) {
            //           this.props.history.replace(`/knowledge/${payload.id}`)
            //         }

            //         const parsedValue = defaultMarkdownParser.parse(
            //           payload?.content,
            //         )

            //         this.setState({
            //           content: parsedValue,
            //           title: payload?.title,
            //           initialContent: parsedValue,
            //           initialTitle: payload?.title,
            //           loading: false,
            //         })
            //       }
            //     })
            // }}
            style={{
              position: 'absolute',
              bottom: 20,
              right: 20,
              color: buttonDisabled ? 'rgba(0, 0, 0, 0.26)' : '#fff',
              backgroundColor: buttonDisabled
                ? 'rgba(0, 0, 0, 0.12)'
                : '#15b940',
            }}
          >
            {this.props.id === 'new' ? 'CREATE' : 'UPDATE'}
          </Button>
        </div>
      </div>
    )
  }
}

export default connect(
  (state, { match }) => {
    return {
      id: state.view.dialogs?.AddOrEditKnowledge?.id || match?.params?.id,
      content: state.view.dialogs?.AddOrEditKnowledge?.content,
      title: state.view.dialogs?.AddOrEditKnowledge?.title,
      dialog: state.view.dialogs?.AddOrEditKnowledge?.open,
      editing: state.view.dialogs?.AddOrEditKnowledge?.editing,
    }
  },
  dispatch => bindActionCreators({ read, create, toggleDialog }, dispatch),
)(AddOrEditKnowledgePage)
